/* Yayın ekranı — düğme, ve düğmenin çalışıp çalışmayacağının cevabı.

   Site üretilmiş HTML (plan §7): veritabanı değişince sayfa kendiliğinden
   değişmiyor. Bu ekran o boşluğu görünür kılıyor — yönetici bir albümü
   yayına aldıktan sonra "neden sitede görünmüyor" diye sormamalı.

   Sistemin bütün bağlamaları Sağlık sekmesinde (views/health.ts). Burada
   yalnızca düğmeyi ilgilendiren tek bağlama soruluyor: yayın tetiği. */

import { health, publish } from '../api.ts';
import { el, replace } from '../dom.ts';
import type { AppContext } from '../main.ts';

export async function renderPublish(host: HTMLElement, ctx: AppContext): Promise<void> {
  const status = el('p', { class: 'note', text: 'Durum okunuyor…' });
  const run = el('button', { type: 'button', class: 'primary', text: 'Siteyi yayınla' });

  run.onclick = async () => {
    run.disabled = true;
    run.textContent = 'Kuyruğa alınıyor…';
    try {
      const result = await publish.run();
      /* "Kuyruğa alındı", "yayımlandı" değil: GitHub olayı kabul etti,
         derleme daha bitmedi ve düşebilir de (routes/adminPublish.ts). */
      status.replaceChildren(
        `Derleme kuyruğa alındı (${new Date(result.queuedAt).toLocaleTimeString('tr-TR')}). `,
        el('span', { class: 'dim', text: 'Bitmesi birkaç dakika sürer.' })
      );
      ctx.toast('Derleme kuyruğa alındı.');
    } catch (err) {
      ctx.fail(err);
    } finally {
      run.disabled = false;
      run.textContent = 'Siteyi yayınla';
    }
  };

  replace(
    host,
    el('h1', { text: 'Yayın' }),
    el('p', {
      class: 'note',
      text:
        'Site üretilmiş HTML olarak duruyor. Bir albümü yayına almak onu sitede ' +
        'göstermez — bu düğme siteyi yeniden üretir.'
    }),
    el('div', { class: 'row' }, run),
    el('div', { style: 'height:10px' }),
    status,
    el('p', { class: 'dim' }, 'Sistemin geri kalanının durumu: ', el('a', { href: '#/saglik', text: 'Sağlık', style: 'color:inherit' }), '.')
  );

  try {
    const report = await health();
    if (!report.bindings['publish']) {
      run.disabled = true;
      status.replaceChildren(
        el('span', {
          class: 'bad',
          text: 'Yayın tetiği yapılandırılmamış — GITHUB_DISPATCH_TOKEN gizi ya da PUBLISH_REPO eksik.'
        })
      );
    } else {
      status.replaceChildren('Hazır.');
    }
  } catch (err) {
    status.replaceChildren(el('span', { class: 'err', text: 'Durum okunamadı.' }));
    ctx.fail(err);
  }
}
